import {customAxios as axios} from "../../../request";
import {getPatientVisitUrl} from "../apis";

export const getPatientVisitFxn = async (valData) => {
    let config = {
        params: valData
    }
    let {data} = await axios.get(getPatientVisitUrl(), config);
    return data;
}